import { render, staticRenderFns } from "./ValidationView.vue?vue&type=template&id=5a936d48"
import script from "./ValidationView.vue?vue&type=script&lang=ts"
export * from "./ValidationView.vue?vue&type=script&lang=ts"
import style0 from "./ValidationView.vue?vue&type=style&index=0&id=5a936d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports